import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PrioridadFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PRIORIDAD' htmlFor='select-prioridad' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='prioridad'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-prioridad'>
              <option value='BAJA'>Baja</option>
              <option value='NORMAL'>Normal (Media)</option>
              <option value='ALTA'>Alta</option>
              <option value='URGENTE'>Urgente</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PrioridadFormGroup)
